import { Box, Stack } from "@mui/material";
import React from "react";
import { Color } from "../constants";

const FettiRadio = ({ selected, size = "16px" }) => {
  return (
    <Stack
      direction="column"
      alignItems="center"
      justifyContent="center"
      sx={{
        width: size,
        height: size,
        borderRadius: "50%",
        backgroundColor: selected ? Color.primary : "#F5F5F5",
        border: "1px solid #E0E0E0",
      }}>
      <Box
        sx={{
          width: size,
          height: size,
          borderRadius: "50%",
          backgroundColor: "black",
          transform: selected ? "scale(0.35)" : "scale(0)",
          transition: "transform 0.2s ease-in-out",
        }}
      />
    </Stack>
  );
};

export default FettiRadio;
